export const MoveIcon: React.FC<{ size?: number; color?: string }> = ({
  size,
  color,
}) => (
  <svg
    width={size || 16}
    height={size || 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color || "currentColor"}
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 7h5.5l1.8 2H21v9a1 1 0 01-1 1H4a1 1 0 01-1-1z" />
    <path d="M9.5 14h6" />
    <path d="M13.5 12l2 2-2 2" />
  </svg>
);
